import PropTypes from 'prop-types';
import MenuPosition from 'src/components/Menu/MenuPosition';
import MenuCategoryHeader from 'src/components/Menu/MenuCategoryHeader';

const MenuItemRenderer = ({ data: { id, type, ...rest }, containerId }) => {
    if (type === 'category') {
        const container = document.querySelector(`#${containerId} > div`);
        const width = container ? container.clientWidth : 0;

        return (
            <MenuCategoryHeader
              key={id}
              id={id}
              masonryFullWidth
              {...rest}
              style={{
                  width
              }}
            />
        );
    }

    if (type === 'position') {
        return (
            <MenuPosition
              key={id}
              id={id}
              {...rest}
            />
        );
    }

    return <div />;
};

MenuItemRenderer.propTypes = {
    containerId: PropTypes.string.isRequired,
    data: PropTypes.shape({
        id: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired
    })
};

export default MenuItemRenderer;
